import { useListenKey } from "@hooks/useListenKey";


type HotKeysHandlerProps = {
    handleNext: () => void;
    handlePrevious: () => void;
}

const HotKeysHandler = ({ handleNext, handlePrevious}: HotKeysHandlerProps) => {
    useListenKey(null, handleNext, "ArrowRight", { listenChild: true, global: true });
    useListenKey(null, handleNext, " ", { listenChild: true, global: true });
    useListenKey(null, handlePrevious, "ArrowLeft", { listenChild: true, global: true });
    return null;
}

export default HotKeysHandler;